import { render, staticRenderFns } from "./ChipSample.vue?vue&type=template&id=58b07dff&scoped=true&"
import script from "./ChipSample.vue?vue&type=script&lang=js&"
export * from "./ChipSample.vue?vue&type=script&lang=js&"
import style0 from "./ChipSample.vue?vue&type=style&index=0&id=58b07dff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b07dff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VRow})
